import Clarity from '@microsoft/clarity';

declare global {
    interface Window {
        clarityConsentSent?: boolean;
        clarity?: (command: string, value?: string) => void;
    }
}

export const ClarityHandler = {
    isClarityInitialized: false,
    projectId: '',
    pendingUserId: undefined as string | undefined,
    pendingEmail: undefined as string | undefined,

    initClarity: (projectId: string, userId?: string, email?: string) => {
        ClarityHandler.projectId = projectId;
        ClarityHandler.pendingUserId = userId;
        ClarityHandler.pendingEmail = email;

        const savedConsent = localStorage.getItem('clarity_consent');
        
        if (savedConsent === 'granted') {
            ClarityHandler.startClarity(projectId);
            ClarityHandler.sendConsentToClarity(true);
            ClarityHandler.identifyUser(userId, email);
        }
    },

    startClarity: (projectId: string) => {
        if (!ClarityHandler.isClarityInitialized) {
            Clarity.init(projectId);
            ClarityHandler.isClarityInitialized = true;
            console.log('🎯 Clarity started recording!');
        }
    },

    identifyUser: (userId?: string, email?: string) => {
        if (ClarityHandler.isClarityInitialized && userId) {
            Clarity.identify(userId, undefined, undefined, email);
            console.log('👤 User identified in Clarity:', userId);
        }
    },

    sendConsentToClarity: (consentGiven: boolean) => { 
        localStorage.setItem('clarity_consent', consentGiven ? 'granted' : 'denied');
        if (window.clarityConsentSent) return;
        if (typeof window.clarity === 'function'){
            window.clarity('consent', consentGiven ? 'granted' : 'denied');
            window.clarityConsentSent = true; 
        } else if (consentGiven) {
            setTimeout(() => ClarityHandler.sendConsentToClarity(consentGiven), 1000); 
        } 
    },

    handleUserConsent: (accepted: boolean, userId?: string, email?: string) => {
        if (accepted) {
            if (!ClarityHandler.isClarityInitialized && ClarityHandler.projectId) {
                ClarityHandler.startClarity(ClarityHandler.projectId);
            }
            
            ClarityHandler.sendConsentToClarity(true);
            
            const finalUserId = userId || ClarityHandler.pendingUserId;
            const finalEmail = email || ClarityHandler.pendingEmail;
            ClarityHandler.identifyUser(finalUserId, finalEmail);
        } else {
            localStorage.setItem('clarity_consent', 'denied');
            console.log('❌ User rejected tracking');
        }
    },
};
